// removed by extract-text-webpack-plugin
module.exports = {"container":"AffirmPromo__container__9442aea5","learnMoreButton":"AffirmPromo__learnMoreButton__9442aea5","promoCopy":"AffirmPromo__promoCopy__9442aea5"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Affirm/AffirmPromo.scss
// module id = 3471
// module chunks = 4